/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable camelcase */
/* eslint-disable import/no-cycle */
import { toast } from 'react-toastify';
import TimbrarApi from '../../api/TimbrarApi';
import { openModal } from './modalActions';
import { changeTab } from './tabActions';
import {
  selectOrder,
  fetchAllOrders,
} from './orderActions';
import { loading, loaded } from './loadActions';

export const FETCH_TIMBRADO = 'FETCH_TIMBRADO';
export const HANDLE_MAKEBILL = 'HANDLE_MAKEBILL';
export const PRINT_BILL = 'PRINT_BILL';
export const RESET_TIMBRADO = 'RESET_TIMBRADO';
export const SAVE_TIMBRADO = 'SAVE_TIMBRADO';

const ID = 'timbrar';

export const resetTimbrado = () => (
  async (dispatch) => {
    dispatch({ type: RESET_TIMBRADO });
  }
);


export const printTicketFactura = (crmid) => {
  const timbrarApi = new TimbrarApi();
  return async (dispatch) => {
    await dispatch(loading(ID));
    timbrarApi.getTicket(crmid)
      .then(async (response) => {
        if (!response.success) {
          toast.warn(response.message.warning || response.message.error);
        } else {
          const { result } = response;
          await dispatch({
            type: PRINT_BILL,
            result,
          });
          await (dispatch(openModal('ticketsFactura')));
        }
      }).catch(() => {
        dispatch(loaded(ID));
      });
  };
};

export const fetchTimbrado = (crmid, history = {}) => (
  async (dispatch) => {
    await dispatch(openModal(ID));
    await dispatch(loading(ID));
    const timbrarApi = new TimbrarApi();
    const response = await timbrarApi.get(crmid);
    const { datos } = response;
    if (response.success !== 'ERROR' && datos) {
      await dispatch({
        type: FETCH_TIMBRADO,
        response: { ...datos, crmid },
      });
    } else {
      await toast.warn(datos);
      if (Object.keys(history).length > 0) history.goBack();
    }
    await dispatch(loaded(ID));
  }
);

export const saveTimbrado = (timbre, history = {})=> (
  async (dispatch, getState) => {
    dispatch(loading(ID));
    try {
      const timbrarApi = new TimbrarApi();
      const response = await timbrarApi.save(timbre);
      const resStr = Object.entries(response)
        .map(x => x[1])
        .join('')
        .match(/{(.*)}/)
        .pop();
      const json = JSON.parse((`{${resStr}}`));
      const { datos, success } = json;
      if (success === 'OK') {
        const { authUser } = getState();
        await dispatch(fetchAllOrders());
        const { pos_sell_tab } = authUser.user.config;
        if (pos_sell_tab) {
          await dispatch(selectOrder(timbre.crmid));
          await dispatch(changeTab('posType', 'Historico'));
          toast.success('Tu orden ya esta timbrada');
        } else {
          toast.success('Orden Timbrada');
        }
        await dispatch(printTicketFactura(json.datos));
      } else {
        toast.warn(datos);
      }
    } catch (err) {
      toast.warn(`Hubo un error durante el proceso timbrado de la orden ${timbre.crmid}`);
      console.log('err: ', err);
    } finally {
      if (Object.keys(history).length > 0) await history.goBack();
      dispatch({ type: SAVE_TIMBRADO });
      dispatch(loaded(ID));
    }
  }
);

export const handleMakeBill = makeBill => (
  async (dispatch) => {
    dispatch(loading(ID));
    dispatch({ type: HANDLE_MAKEBILL, makeBill });
    dispatch(loaded(ID));
  }
);
